import {ShellBase} from '@/entryPoints/lib/shell-base';

class Shell extends ShellBase {
  constructor(pageComponents = {}, vueRouter = {}) {
    super(pageComponents, vueRouter);
  }
}

export {Shell};
